import { Button } from '../Button/NewButton';
import { useState } from 'react';
import { downloadCsv } from '../../lib/csv';
import { TableColumn } from '../../types/commonTypes';
import { Popper } from '../Popper';
import { CardContent } from '../Card';
import { Option } from '../Option';
import { Select } from '../Select/Select';
import { Checkbox } from '../Checkbox';

interface Props {
  anchorElement?: Element | null;
  csvName: string;
  data: any[];
  displayData: any[];
  filteredColumns: TableColumn[];
  formatters?: Record<string, (value: any) => any>;
  filteredData: any[];
  onClose(): void;
  open: boolean;
}

export const CsvDownloadMenu = (props: Props) => {
  const {
    anchorElement = null,
    csvName,
    data,
    displayData,
    filteredColumns,
    filteredData,
    formatters,
    onClose,
    open,
  } = props;
  const [columnSelect, setColumnSelect] = useState<string>('all');
  const [dataSelect, setDataSelect] = useState<string>('all');
  const [includeHeaders, setIncludeHeaders] = useState(true);

  const handleDownload = () => {
    let csvColumns =
      columnSelect === 'filtered'
        ? filteredColumns.filter((c) => !c.isHidden)
        : filteredColumns;

    let csvData =
      dataSelect === 'displayed'
        ? formatData(displayData)
        : dataSelect === 'filtered'
        ? filteredData
        : formatData(data);

    downloadCsv(csvColumns, csvData, csvName, includeHeaders);
    onClose();
  };

  const formatData = (data: any[]) => {
    if (!formatters) return data;

    return data.map((d) => {
      const entries = Object.entries(d);

      let obj = Object.assign({}, d);
      entries.forEach(([key, value]) => {
        const formatter = formatters[key];

        if (!formatter) return;
        obj = Object.assign({}, obj, { [key]: formatter(value) });
      });

      return obj;
    }, []);
  };

  return (
    <Popper
      anchorEl={anchorElement}
      clickAway
      onClose={onClose}
      isVisible={open}
      placement="bottom"
      color="card"
      showArrow
    >
      <CardContent className="grid grid-cols-2 gap-4 w-[300px]">
        <div className="flex grow">
          <div className="flex flex-col grow">
            <label>Columns</label>
            <Select
              fullWidth
              name="columns"
              onChange={(value) => setColumnSelect(value)}
              value={columnSelect}
              variant="contained"
            >
              <Option value="all">All</Option>
              <Option value="filtered">Filtered</Option>
            </Select>
          </div>
        </div>
        <div className="flex flex-col grow">
          <label>Data</label>
          <Select
            fullWidth
            name="data"
            onChange={(value) => setDataSelect(value)}
            value={dataSelect}
            variant="contained"
          >
            <Option value="all">All</Option>
            <Option value="displayed">Displayed</Option>
            <Option value="filered">Filtered</Option>
          </Select>
        </div>
        <div className="flex grow items-center justify-center col-span-full">
          <Checkbox
            label="Include Headers"
            checked={includeHeaders}
            color="primary"
            onChange={() => setIncludeHeaders(!includeHeaders)}
          />
        </div>
        <div className="col-span-full">
          <Button
            onClick={handleDownload}
            variant="contained"
            fullWidth
            typeCasing="capitalize"
          >
            Download
          </Button>
        </div>
      </CardContent>
    </Popper>
  );
};
